"use strict";
/**
 * Created on 10 24 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization API of {@link WindowItemSitesData}.
 *
 * @author JMe
 */


var WindowItemSitesDataConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowItemSitesDataConverter, _DataObjectConverter_);

  function WindowItemSitesDataConverter() {
    _classCallCheck(this, WindowItemSitesDataConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemSitesDataConverter).apply(this, arguments));
  }

  return WindowItemSitesDataConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowItemSitesDataConverter = WindowItemSitesDataConverter;